module.exports = __webpack_public_path__ + "fonts/Inter-Italic.b13e6fe.woff";